import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';
import type FeaturesService from 'tio-common/services/features';
export default class AuthenticatedWellnessInsightsIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;
  @service declare features: FeaturesService;

  queryParams = {
    accountCreationFeedbackActive: { refreshModel: false, replace: true },
  };

  beforeModel() {
    // Redirect if TA-only context
    if (this.partner.isTaOnly) {
      this.router.transitionTo('authenticated.dashboard');
    }
  }

  async model() {
    // Get wellness data from parent authenticated route
    const authenticatedModel = this.modelFor('authenticated') as {
      wellnessData: Record<string, unknown> | null;
      user: { id: string };
    };

    const { wellnessData, user } = authenticatedModel;
    if (!wellnessData) {
      return null;
    }

    const payload = { ...wellnessData, userId: user.id } as Record<string, unknown>;
    const serializer = this.store.serializerFor('wellness-train');
    if (!serializer) {
      return null;
    }

    const modelClass = this.store.modelFor('wellness-train');
    const recordId = `user-${user.id}-wellness-train`;
    const normalized = serializer.normalizeResponse(
      this.store,
      modelClass,
      payload,
      recordId,
      'queryRecord'
    ) as Parameters<StoreService['push']>[0];

    if (!normalized?.data || Array.isArray(normalized.data)) {
      return null;
    }

    this.store.push(normalized);
    return this.store.peekRecord('wellness-train', recordId);
  }
}
